import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, Input, Renderer2 } from '@angular/core';

@Directive({ selector: '[currencyInput]' })
export class CurrencyInputDirective implements AfterViewInit {
    @Input() maxValue = 99999999999999;
    @Input() minValue = 0;
    @Input() placeHolder = '';
    @Output() ngModelChange: EventEmitter<number> = new EventEmitter(false);
    @Input() digits = 0;

    private _isInitialized = false;

    constructor(private _element: ElementRef, private renderer: Renderer2) {      
    }
   
    ngAfterViewInit() {
        if (this._isInitialized) {
            return;
        }
        
        const groupSeparatorCurrency = abp.localization.currentLanguage.name == 'vi' ? '.' : ',';
        const radixPointCurrency = groupSeparatorCurrency == '.' ? ',' : '.';     
      
        $(this._element.nativeElement).inputmask('numeric', {
            radixPoint: radixPointCurrency,
            groupSeparator: groupSeparatorCurrency,
            digits: this.digits,
            autoGroup: true,
            prefix: '',
            rightAlign: false,
            showMaskOnHover: false,
            showMaskOnFocus: false,
            placeholder: this.placeHolder,
            removeMaskOnSubmit: true,
            autoUnmask: true,
            max: this.maxValue,
            min: this.minValue,
            oncleared : () => {
                 if(this._element.nativeElement.value === '') {
                    this.ngModelChange.emit(0);
                 }               
              } ,
            oncomplete: () => {
                this.ngModelChange.emit(this._element.nativeElement.value);
            }       
        });

        this._isInitialized = true;
    }
}
